<div class="head" [ngStyle]="{'padding-top':alerttop+'px'}"></div>
<div #closeblock class="alert alert-danger text-center siteclose" [hidden]="!siteClose">
    {{siteCloseComment}}
</div>
<!-- <div #alertblock class="alert alert-danger alert-dismissible text-center siteclose" [hidden]="siteClose || !alert || closealert">
    {{alert}}
    <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="closealert=true;alerttop=150;">
        <span aria-hidden="true">&times;</span>
    </button>
</div> -->
<best-sales *ngIf="displayBestSales"></best-sales>
<best-offers *ngIf="displayBestOffers"></best-offers>
<carte [header]="alerttop"></carte>